import React from "react"
import Flatpickr from "react-flatpickr"
import { Greek } from "flatpickr/dist/l10n/gr"
import "flatpickr/dist/themes/light.css"
import { Form, Button } from "react-bootstrap"
import "./DateTimePicker.css" // We'll create this file next

const DateTimePicker = ({
  value,
  onChange,
  disabled,
  enableTime = true,
  enableSeconds = false,
  label,
  showClearButton = true,
  onClear,
  isInvalid,
  className = "",
  placeholder = "Επιλέξτε ημερομηνία...",
  minDate,
  allowInput = true
}) => {
  const options = {
    locale: Greek,
    enableTime: enableTime,
    enableSeconds,
    time_24hr: true,
    dateFormat: enableTime ? (enableSeconds ? "d/m/Y H:i:S" : "d/m/Y H:i") : "d/m/Y",
    allowInput: allowInput,
    disableMobile: true,
    minuteIncrement: 1,
    minDate: minDate || null
    // Format the date without timezone conversion
    /* formatDate: (date, format) => {
             const pad = (num) => num.toString().padStart(2, '0')
             const year = date.getFullYear()
             const month = pad(date.getMonth() + 1)
             const day = pad(date.getDate())
             const hours = pad(date.getHours())
             const minutes = pad(date.getMinutes())
             const seconds = pad(date.getSeconds())
 
             if (format === 'Y-m-d H:i:S') {
                 return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`
             } else if (format === 'Y-m-d H:i') {
                 return `${day}-${month}-${year} ${hours}:${minutes}`
             }
             return `${day}-${month}-${year}`
         }*/
  }

  return (
    <Form.Group className="datetime-picker-container">
      {label && <Form.Label className="fw-medium">{label}</Form.Label>}
      <div className="d-flex gap-2">
        <div className={`flex-grow-1 ${className}`}>
          <Flatpickr
            value={value}
            options={options}
            className={`form-control ${isInvalid ? "is-invalid" : ""}`}
            disabled={disabled}
            placeholder={placeholder}
            onClose={(dates, currentdatestring, picker) => {
              if (dates.length === 0) {
                picker.setDate(currentdatestring, true, picker.config.altFormat)
              }
              onChange(dates?.[0] ?? currentdatestring)
            }}
          />
        </div>
        {showClearButton && (
          <Button
            variant="outline-secondary"
            onClick={() => {
              onChange(null)
              onClear?.()
            }}
            disabled={disabled || !value}>
            <i className="fas fa-times" />
          </Button>
        )}
      </div>
    </Form.Group>
  )
}

export default DateTimePicker
